export const handleIsActive = (value) => {
  if (value == null) {
    return "";
  } else if (value) {
    return "Active";
  }
  return "Inactive";
};

export const showPopupDetails = (field) => {
  return field != null && field !== "" ? field : "-";
};

export const urlWithFilterParams = (filter) => {
  let params = new URLSearchParams();
  for (const key in filter)
    if (filter.hasOwnProperty(key) && filter[key])
      params.append(key, filter[key]);

  const queryString = params.toString();
  return queryString;
};

export const isDefinedAndNotEmpty = (value) => {
  return value !== null && value !== undefined && value !== "";
};

export const componentIsVisible = (component, user) => {
  let components = user?.components;
  return components?.some((item) => item?.componentCode === component);
};

export const componentIsEditable = (component, user) => {
  let components = user?.components;
  return components?.some(
    (item) => item?.componentCode === component && item?.editable === true
  );
};

export const auditLogFormatAction = (row) => {
  let actionLog = "";
  // format the operation performed (update, create)
  let operation = row?.source.includes("~") ? row.source.split("~")[1] : "";
  const operationMapping = {
    update: "Updated",
    create: "Created",
  };
  operation = operationMapping[operation] || operation;

  // format the text for the screen on which the operation was performed
  const prefixes = ["com.ids.model.", "com.ids.dto."];
  const matchingPrefix = prefixes.find((prefix) =>
    row?.source.startsWith(prefix)
  );
  let screen = matchingPrefix
    ? row?.source.replace(matchingPrefix, "").split("~")[0]
    : row?.source.split("~")[0];
  screen = screen.replace("View", "");

  // format the text for the fields that were updated
  if (operation === "Updated") {
    actionLog = `${operation} ${screen} ${row?.sourceCode}, field ${row?.sourceField} from ${row?.sourceValue} to ${row?.actionValue}`;
  } else if (operation === "Created") {
    actionLog = `${operation} ${screen} ${row?.sourceCode}`;
  } else if (row?.source === "Message") {
    actionLog = `Updated transaction ${row?.transactionId}, field ${row?.sourceField} from ${row?.sourceValue} to modified value ${row?.actionValue}`;
  }

  return actionLog;
};

export const transactionLogFormatAction = (row) => {
  let actionLog = "";
  if (row?.source === "Translation" || row?.source === "Normalization") {
    actionLog = `${row?.source} of value within data segment field ${row?.sourceField} from ${row?.sourceValue} to modified value ${row?.actionValue}`;
  } else if (row?.source === "Updation") {
    actionLog = `Updated transaction ${row?.transactionId}, field ${row?.sourceField} from ${row?.sourceValue} to modified value ${row?.actionValue}`;
  } else {
    actionLog = row?.sourceField;
  }
  return actionLog;
};

export const validateAndSanitizeUrl = (url) => {
  const expectedUrl = "https://static-content.idphrulesengine.com/";
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.href === expectedUrl) {
      return parsedUrl.href;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};
